"use client";

import React from "react";
import { CalendarClock, Computer } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const countdownBlocks = [{
  label: "Years Exp",
  value: "17"
}, {
  label: "Star Rating",
  value: "5.0"
}, {
  label: "Credentials",
  value: "03"
}, {
  label: "TUTORING HOURS",
  value: "3000+"
}];
export default function ReadyForTaxSeason() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll<HTMLElement>({
    threshold: 0.2
  });
  const {
    ref: countdownRef,
    isVisible: countdownVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  return <section data-section-id="232359" id="ready-to-excel" ref={sectionRef} className="dark bg-background text-foreground relative overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none" style={{
      background: "radial-gradient(circle at 20% 30%, hsl(209 100% 14% / 0.4) 0%, transparent 70%), radial-gradient(circle at 80% 70%, hsl(43 96% 58% / 0.1) 0%, transparent 70%)"
    }} />

      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[700px] h-[400px] pointer-events-none opacity-10 blur-3xl" style={{
      background: "radial-gradient(ellipse at center, var(--secondary) 0%, transparent 70%)"
    }} />

    <div className="relative z-10 max-w-5xl mx-auto px-6 py-20 md:py-28 flex flex-col items-center text-center gap-10">

      {}
      <div className={`transition-all duration-700 ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        <span className="inline-flex items-center gap-2 text-xs font-mono uppercase tracking-widest px-4 py-2 rounded-md border" style={{
          color: "var(--primary)",
          borderColor: "var(--primary)",
          background: "hsl(43 96% 58% / 0.1)"
        }}>
          <Computer className="w-4 h-4" />
          Certified VIRTUAL TEACHING
        </span>
      </div>

      {}
      <div className={`transition-all duration-700 delay-150 ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        <h2 className="font-default text-4xl md:text-6xl lg:text-7xl font-bold leading-tight tracking-tight" style={{
          color: "var(--foreground)"
        }}>
          Ready to{" "}
          <span className="relative inline-block font-serif" style={{
            color: "var(--primary)"
          }}>
            Excel?
            <span className="absolute -bottom-1 left-0 w-full h-0.5 rounded-lg" style={{
              background: "var(--primary)"
            }} />
          </span>
        </h2>
        <p className="mt-5 text-base md:text-lg max-w-xl mx-auto font-default leading-relaxed" style={{
          color: "var(--muted-foreground)"
        }}>Strengthen understanding and build confidence with personalized lessons from a UC Berkeley graduate. Experience high standards for mathematical teaching and learning.&nbsp;</p>
      </div>

      {}
      <div ref={countdownRef} className={`w-full max-w-xl transition-all duration-700 delay-300 ${countdownVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="grid grid-cols-4 gap-3 md:gap-4">
          {countdownBlocks.map((block, i) => <div data-index={i} key={block.label} className="flex flex-col items-center gap-1.5 rounded-lg px-3 py-4 border" style={{
            background: "hsl(209 100% 12% / 0.8)",
            borderColor: "var(--border)",
            backdropFilter: "blur(8px)"
          }}>
              <span className="font-mono text-3xl md:text-4xl font-bold tabular-nums" style={{
              color: "var(--primary)"
            }}>
                {block.value}
              </span>
              <span className="uppercase tracking-widest font-mono !text-[11px]" style={{
              color: "var(--muted-foreground)"
            }}>
                {block.label}
              </span>
            </div>)}
        </div>
        <p className="mt-3 font-mono uppercase tracking-widest text-center !text-base" style={{
          color: "var(--muted-foreground)"
        }}>Start your journey with a free initial assessment</p>
      </div>

      {}
      <div className="w-16 h-px rounded-lg" style={{
        background: "var(--primary)"
      }} />

      {}
      <div className={`transition-all duration-700 delay-500 ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
        <Button asChild size="lg" className="font-default text-base px-8 py-6 h-auto rounded-md shadow-lg hover:shadow-xl transition-shadow" style={{
          background: "var(--primary)",
          color: "var(--primary-foreground)"
        }}>
          <Link to="/StartLearningPage">Schedule My Assessment</Link>
        </Button>
        <p className="mt-4 text-xs font-default" style={{
          color: "var(--muted-foreground)"
        }}>
          Virtual Sessions &bull; One-on-One &bull; Small Groups &bull; CA & AZ Certified
        </p>
      </div>
    </div>
  </section>;
}